<capra-toast type="success" [inline]="true" [showCloseBtn]="true" [canTapToDismiss]="false" (dismissToast)="dismissToast()">
  <div class="google-sheet-ingest-success-content">
    <p class="success-message">Your Dataset is ready</p>
    <capra-button
      class="import-cta"
      (click)="clickUseInNewReport()"
      variant="secondary"
      color="neutral"
      size="small"
      text="Use in new Report"
    ></capra-button>
    <capra-button-link
      class="edit-report-cta"
      data-test="edit-report-cta"
      [href]="editDatasetLink"
      variant="primary"
      color="neutral"
      size="small"
      text="Edit"
    ></capra-button-link>
  </div>
</capra-toast>
